import React, { useState, useEffect } from 'react';

const EditItemDialog = ({ open, item, onClose, onSaved }) => {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  // 🔥 Sync item → form when dialog opens
  useEffect(() => {
    if (open && item) {
      setForm({ ...item });
    }
  }, [open, item]);

  if (!open || !form) return null;


  const handleChange = (key, value) => {
    setForm(prev => ({ ...prev, [key]: value }));
  };

  const handleSave = async () => {
    try {
      setSaving(true);

      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/items/${form.id}`,
        {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(form)
        }
      );

      if (!res.ok) {
        throw new Error('Failed to update item');
      }

      const updatedItem = await res.json();

      onSaved(updatedItem); // 🔥 return updated item
      onClose();
    } catch (err) {
      alert(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal fade show d-block" style={{ background: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">

          <div className="modal-header">
            <h5 className="modal-title poppin">Edit Item</h5>
            <button className="btn-close" onClick={onClose} />
          </div>

          <div className="modal-body">
            {/* NAME */}
            <div className="mb-3">
              <label className="form-label">Name</label>
              <input
                className="form-control"
                value={form.name}
                onChange={e => handleChange('name', e.target.value)}
              />
            </div>

            {/* PRICE */}
            <div className="mb-3">
              <label className="form-label">Price (£)</label>
              <input
                type="number"
                step="0.01"
                className="form-control"
                value={form.price}
                onChange={e => handleChange('price', e.target.value)}
              />
            </div>

            {/* DESCRIPTION */}
            <div className="mb-3">
              <label className="form-label">Description</label>
              <textarea
                className="form-control"
                rows="3"
                value={form.description || ''}
                onChange={e => handleChange('description', e.target.value)}
              />
            </div>

            {/* PREP TIME */}
            <div className="mb-3">
              <label className="form-label">Prep Time (mins)</label>
              <input
                type="number"
                className="form-control"
                value={form.estimated_prep_time_mins || ''}
                onChange={e =>
                  handleChange('estimated_prep_time_mins', e.target.value)
                }
              />
            </div>

            {/* AVAILABILITY */}
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                checked={form.is_available}
                onChange={e =>
                  handleChange('is_available', e.target.checked)
                }
              />
              <label className="form-check-label">
                Available
              </label>
            </div>
          </div>

          <div className="modal-footer">
            <button
              className="btn btn-secondary"
              onClick={onClose}
              disabled={saving}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={handleSave}
              disabled={saving}
            >
              {saving ? 'Saving…' : 'Save Changes'}
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default EditItemDialog;
